import { Injectable, OnDestroy } from "@angular/core";
import { LogBookLog, LogConfig } from "ng/src/app/logs/log.model";
import { LogService } from "ng/src/app/logs/log.service";
import { BehaviorSubject, Observable, of, Subject } from "rxjs";

/**
 * State management service for provisioning and subcomponents.
 * TODO: On Angular conversion, move into a log-settings service.
 */
@Injectable()
export class ProvisioningService implements OnDestroy {
	
	readonly selectedLog = new BehaviorSubject<LogBookLog | undefined>(undefined);
	
	private readonly _onDestroy = new Subject<void>();
	
	constructor(logService: LogService) {}
	
	ngOnDestroy(): void {
		this.selectedLog.complete();
		this._onDestroy.next();
	}
}